export const environment = {
  isProd: false,
  markdownEditorUrl: 'https://editor.chat-beta.quik-ai.com/editor',
};
